<tr>
    <ng-container *ngFor="let group of theadGroups">
        <th *ngIf="group.columns.length > 1" [attr.colspan]="group.columns.length">{{ group.header }}</th>
        <ng-container *ngIf="group.columns.length === 1">
            <th rowspan="2"
                [class]="tableSorter.class(group.columns[0].columnSortingName)"
                (click)="clickEvent(group.columns[0])"
                [innerHTML]="group.columns[0].columnDescription">
            </th>
        </ng-container>
    </ng-container>
</tr>
<tr>
    <ng-container *ngFor="let group of theadGroups">
        <ng-container *ngIf="group.columns.length > 1">
            <th *ngFor="let col of group.columns"
                style="border-left: 1px solid #dfe4f2; padding: 5px;"
                [class]="col?.columnSortingName ? tableSorter.class(col.columnSortingName) : ''"
                (click)="clickEvent(col)"
                [innerHTML]="col.columnDescription"
            >
            </th>
        </ng-container>
    </ng-container>
</tr>

